import React from 'react';
import { StarIcon } from 'lucide-react';
import { HeroAvatars } from './HeroAvatars';
import { mainGuide } from '../data/resources';
import { siteConfig } from '../data/siteConfig';
export function Hero() {
  const {
    trust,
    heroVideoUrl
  } = siteConfig;
  const rating = trust.rating;
  return <section className="bg-ivory px-5 sm:px-8 pt-8 pb-12 sm:pt-14 sm:pb-16 overflow-hidden" data-id="element-82" data-mp="4mi2n8mfxkdf">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-83" data-mp="12a0kd8y2xwtk">
        <p className="inline-flex items-center rounded-full border border-coral-deep/40 px-3 sm:px-4 py-1.5 text-xs font-semibold tracking-[0.04em] sm:tracking-[0.12em] whitespace-normal text-coral-deep" data-id="element-84" data-mp="xae5yw6imaj6">
          IMPRIMEZ · TRACEZ · PEIGNEZ · CRÉEZ
        </p>

        <h1 className="mt-5 font-serif text-[2.15rem] leading-[1.1] sm:text-5xl lg:text-[3.6rem] font-semibold text-teal text-balance" data-id="element-85" data-mp="nbyh6zuyndcu">
          Transformez de simples objets en{' '}
          <span className="italic font-medium text-coral-deep" data-id="element-86" data-mp="381nqyygt48yo">créations lumineuses</span>{' '}
          grâce au faux vitrail.
        </h1>

        <p className="mt-5 max-w-xl text-base sm:text-lg leading-relaxed text-ink/80" data-id="element-87" data-mp="3o7ls3r2jl6oy">
          Même si vous n’avez jamais peint, créez vos premières pièces avec nos guides pas à pas et plus de 100 modèles à tracer. Pour embellir votre intérieur, offrir un cadeau unique ou simplement vous faire plaisir.
        </p>

        {rating !== null && <div className="mt-6 inline-flex max-w-full items-center gap-3 rounded-2xl sm:rounded-full border border-gold/40 bg-ivory px-4 py-2.5 shadow-soft text-left" data-id="element-88" data-mp="30gzwx0dmzgwd">
            <HeroAvatars data-id="element-89" data-mp="2qk3kwkoj4cn2" />
            <span className="flex flex-col sm:flex-row sm:items-center gap-x-2 gap-y-0.5" data-id="element-90" data-mp="2qkmune40zuq0">
              <span className="flex items-center gap-2" data-id="element-91" data-mp="2vi54d6pvadz2">
                <span className="flex gap-0.5 text-gold" role="img" aria-label={`Note moyenne ${rating.toLocaleString('fr-FR')} sur 5`} data-id="element-92" data-mp="2vglmxcsh5wvp">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} size={14} aria-hidden="true" className="fill-current" data-id="element-93" data-mp="s21h48i0i7ye" data-mpi={i} />)}
                </span>
                <span className="text-sm font-semibold text-ink whitespace-nowrap" data-id="element-94" data-mp="nbl1chqpya8v">
                  {rating.toLocaleString('fr-FR')} / 5
                </span>
              </span>
              <span className="text-sm text-ink/80" data-id="element-95" data-mp="dd5cklf5zd2j">
                <span aria-hidden="true" className="hidden sm:inline" data-id="element-96" data-mp="degd8cdbc4pf">· </span>
                {trust.customerLabel}
              </span>
            </span>
          </div>}

        <div className="relative mt-9 w-full max-w-[340px] sm:max-w-[400px]" data-id="element-97" data-mp="161b0fh1ili6l">
          <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] border-[6px] border-white bg-sand shadow-frame ring-1 ring-coral/30" data-id="element-98" data-mp="112pv537eo8ba">
            {heroVideoUrl ? <video src={heroVideoUrl} autoPlay muted loop playsInline controls={false} disablePictureInPicture preload="auto" className="h-full w-full object-cover" data-id="element-99" data-mp="x0uy4awich3b" /> : <img src={mainGuide.image} alt={mainGuide.imageAlt} decoding="async" className="h-full w-full object-cover" data-id="element-100" data-mp="3hr3sjxze2f6v" />}

            <span className="pointer-events-none absolute left-3 top-3 rounded-full bg-ivory/95 px-3 py-1.5 text-xs font-semibold text-teal shadow-soft" data-id="element-101" data-mp="1xam4cnf59kxc">
              Guide + 5 bonus
            </span>
            {!heroVideoUrl && <span aria-hidden="true" className="pointer-events-none absolute bottom-3 right-3 flex h-[84px] w-[84px] flex-col items-center justify-center rounded-full bg-coral-deep text-white shadow-soft ring-4 ring-white/70" data-id="element-102" data-mp="268oblkph19t2">
                <span className="font-serif text-2xl font-bold leading-none" data-id="element-103" data-mp="2kyna5okxun92">100+</span>
                <span className="mt-0.5 text-xs font-semibold" data-id="element-104" data-mp="2l0q7ktof7int">modèles</span>
              </span>}
          </div>
          {heroVideoUrl && <span aria-hidden="true" className="pointer-events-none absolute -top-3 right-3 flex h-[76px] w-[76px] flex-col items-center justify-center rounded-full bg-coral-deep text-white shadow-soft ring-4 ring-ivory" data-id="element-105" data-mp="2u03ilqs70fan">
              <span className="font-serif text-xl font-bold leading-none" data-id="element-106" data-mp="zmc2c8fcyx68">100+</span>
              <span className="mt-0.5 text-xs font-semibold" data-id="element-107" data-mp="4akwoxpqsifg">modèles</span>
            </span>}
        </div>

        <a href="#offre" className="mt-9 inline-flex min-h-[52px] w-full sm:w-auto items-center justify-center whitespace-normal rounded-full bg-coral-deep px-4 sm:px-9 py-4 text-base font-semibold text-white shadow-soft transition-colors duration-200 hover:bg-coral-darker" data-id="element-108" data-mp="3vgniivb5q1sf">
          Je crée mes premières pièces — {siteConfig.price}
        </a>
        <p className="mt-3.5 text-sm text-ink/70" data-id="element-109" data-mp="3hnxs8eoliapi">
          Paiement unique · Produit numérique · Matériel non inclus
        </p>
      </div>
    </section>;
}